(() => {
  function setup(root = document) {
    root.querySelectorAll('[data-slideshow]').forEach(el => {
      if (el.dataset.ready) return;
      el.dataset.ready = 'true';
      const slides = [...el.querySelectorAll('[data-slide]')];
      const controls = el.querySelector('.cz-slide-controls');
      if (slides.length < 2) return;
      controls.hidden = false;
      let index = 0, timer, paused = el.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches;
      const pause = el.querySelector('[data-slide-pause]');
      const render = () => {
        slides.forEach((s, i) => { s.hidden = i !== index; s.inert = i !== index; });
        el.querySelector('[data-slide-count]').textContent = `${index + 1} / ${slides.length}`;
        pause.querySelector('[data-icon-pause]').toggleAttribute('hidden', paused);
        pause.querySelector('[data-icon-play]').toggleAttribute('hidden', !paused);
        pause.setAttribute('aria-label', paused ? pause.dataset.play : pause.dataset.pause);
        pause.title = paused ? pause.dataset.play : pause.dataset.pause;
        pause.setAttribute('aria-pressed', String(paused));
      };
      const stop = () => clearInterval(timer);
      const start = () => { stop(); if (!paused && !document.hidden && !el.matches(':hover') && !el.contains(document.activeElement)) timer = setInterval(() => {index = (index + 1) % slides.length;render();}, Number(el.dataset.interval) || 7000); };
      const go = delta => {index = (index + delta + slides.length) % slides.length;render();start();};
      el.querySelector('[data-slide-prev]').addEventListener('click', () => go(-1));
      el.querySelector('[data-slide-next]').addEventListener('click', () => go(1));
      pause.addEventListener('click', () => {paused = !paused;render();start();});
      el.addEventListener('mouseenter', stop);el.addEventListener('mouseleave', start);
      el.addEventListener('focusin', stop);el.addEventListener('focusout', () => setTimeout(start, 0));
      document.addEventListener('visibilitychange', start);
      el.addEventListener('keydown', e => {if(e.key === 'ArrowRight'){e.preventDefault();go(1);}if(e.key === 'ArrowLeft'){e.preventDefault();go(-1);}});
      document.addEventListener('shopify:block:select', e => { const at=slides.findIndex(s=>s===e.target||s.contains(e.target));if(at>=0){paused=true;index=at;render();stop();}});
      document.addEventListener('shopify:section:unload', e => {if(e.target.contains(el))stop();});
      render();start();
    });
  }
  document.addEventListener('DOMContentLoaded', () => setup());
  document.addEventListener('shopify:section:load', e => setup(e.target));
})();
